import React from 'react';
import PropTypes from 'prop-types';

import XLSX from 'xlsx/xlsx';
import Button from 'components/button';
import styles from './styles.css';

export default class OrdersExportData extends React.Component {
    static propTypes = {
        handleClick: PropTypes.func,
    };

    state = {}

    async handleExport() {
        this.setState({loading: true});
        const orders = await this.props.handleClick();
        const orderData = orders.orders.items.map(order => ({
            Id: order.id,
            Categoría: order.category.name,
            'Creado por': `${order.createdBy.firstName}, ${order.createdBy.lastName}`,
            Email: order.createdBy.email,
            Organización: order.organization.name,
            'Estado del Envío': order.shipments.length > 0 ? order.shipments[0].status.name : '',
            'Guía Envío': order.shipments.length > 0 ? order.shipments[0].trackingId : '',
            Notas: order.extraData.notes,
            'Estado Pedido': order.status.name,
            Total: `${order.total} ${order.totalCurrency}`,
        }));
        const orderDataJson = JSON.parse(JSON.stringify(orderData));
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(orderDataJson);

        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'Listado_Pedidos.xlsx');
        this.setState({loading: false});
    }

    render() {
        return (
            <Button className={styles.downloadButton} onClick={() => this.handleExport()} theme='yellow' disabled={this.state.loading}>
                {this.state.loading ? 'Exportando...' : 'Exportar Selección'}
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-list/order-list-export/index.js